module.exports = __webpack_public_path__ + "static/media/1029615.aed4b059.jpg";